enum ShippingAssignmentStatus {
    All = "Todos",
    ASSIGNED = "Asignados",
    NONASSIGNED = "No asignados"
}

export default ShippingAssignmentStatus;
